export default __webpack_public_path__ + "static/countdown_event-312ceb7c66b34724ac441ce0cee0f117.png";